<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-clock-edit</v-icon>
                Configurazione timbratura
                <v-spacer></v-spacer>
                <v-btn icon @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>

            <v-card-text v-if="!loading">
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="text-subtitle-2 mb-2">Modalita di tracciamento</div>
                        <v-radio-group v-model="form.attendance_mode" hide-details>
                            <v-radio value="clock">
                                <template v-slot:label>
                                    <div>
                                        <strong>Timbratura</strong> <span class="text-caption grey--text">(default)</span>
                                        <div class="text-caption grey--text">Orario reale calcolato dalle timbrature in/out.</div>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio value="shift">
                                <template v-slot:label>
                                    <div>
                                        <strong>Segue il turno</strong>
                                        <div class="text-caption grey--text">Orario derivato dal template turno assegnato. Le timbrature sono opzionali.</div>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio value="none">
                                <template v-slot:label>
                                    <div>
                                        <strong>Esclusa</strong>
                                        <div class="text-caption grey--text">Il dipendente non genera cartellino. Le timbrature sono rifiutate.</div>
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" md="6">
                        <div class="text-subtitle-2 mb-2">Geolocalizzazione</div>
                        <v-radio-group v-model="form.geofence_policy" hide-details :disabled="form.attendance_mode === 'none'">
                            <v-radio value="required">
                                <template v-slot:label>
                                    <div>
                                        <strong>Obbligatoria</strong>
                                        <div class="text-caption grey--text">Timbratura bloccata se il dipendente e fuori dai luoghi autorizzati.</div>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio value="warning">
                                <template v-slot:label>
                                    <div>
                                        <strong>Solo segnalazione</strong> <span class="text-caption grey--text">(default)</span>
                                        <div class="text-caption grey--text">Timbratura permessa anche fuori sede, ma marcata come anomalia.</div>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio value="none">
                                <template v-slot:label>
                                    <div>
                                        <strong>Disabilitata</strong>
                                        <div class="text-caption grey--text">Nessun controllo geofence (smart working / ufficio singolo).</div>
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-divider class="my-4"></v-divider>

                <v-row>
                    <v-col>
                        <v-btn color="primary" :loading="saving" @click="save">
                            <v-icon left small>mdi-content-save</v-icon>
                            Salva configurazione
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'hr-employee-attendance-config',
    props: { id: Number },

    data() {
        return {
            loading: false,
            saving: false,
            form: { attendance_mode: 'clock', geofence_policy: 'warning' },
        }
    },

    methods: {
        load() {
            this.loading = true
            this.axios.get(`hremployees/${this.id}?lite=1`).then(r => {
                this.form.attendance_mode = r.data.model.attendance_mode || 'clock'
                this.form.geofence_policy = r.data.model.geofence_policy || 'warning'
                this.loading = false
            }, () => { this.loading = false })
        },
        save() {
            this.saving = true
            this.axios.put(`hremployees/${this.id}`, this.form).then(() => { this.saving = false }, () => { this.saving = false })
        },
    },

    created() {
        this.$store.commit('endProgress')
        this.load()
    },
}
</script>
